export default {"src":"/_next/static/media/certification.955be2b0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};